module.exports = __webpack_public_path__ + "img/base_divers_pin.d300622a.svg";